import axios from '../assets/axios'

export default {
  namespaced: true,
  state: { },
  mutations: {},
  actions: {
    // 借款可用优惠券
    async loanUseRecordX ({ commit }, params) {
      const response = await axios.post('/coupon/v1/loanUseRecord', params)
      return response.data
    }
    
    // async messageSendSms ({ commit }, params) {
    //   const response = await axios.get(`/message/v1/${params.recordNo}/send-sms`, params)
    //   return response.data
    // }    

  }
}
